import { getApiBaseUrl } from "../config/apiBase";
import { apiFetch } from "../config/apiFetch";

export type IfscLookupResult = {
  ifsc: string;
  bankName: string;
  branchName: string;
  city?: string;
  state?: string;
};

async function parseError(res: Response): Promise<string> {
  const text = await res.text();
  try {
    const j = JSON.parse(text) as { error?: string };
    if (j.error) return j.error;
  } catch {
    /* ignore */
  }
  return text || `Request failed (${res.status})`;
}

/** Resolve bank and branch name from IFSC (server proxies Razorpay public API). */
export async function lookupIfsc(ifsc: string, signal?: AbortSignal): Promise<IfscLookupResult> {
  const code = String(ifsc ?? "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, 11);
  const res = await apiFetch(`${getApiBaseUrl()}/api/ifsc-lookup/${encodeURIComponent(code)}`, { signal });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<IfscLookupResult>;
}
